import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getProfile, updateProfile, uploadProfileImage } from "../../api/user"
// ===============================
// Initial State
// ===============================
const initialState = {
  user: null,
  checked: false,
  loading: false,
  error: null,
  message: null
}


// ===============================
// 1 -> Get Profile
// ===============================
export const fetchProfile = createAsyncThunk(
  "user/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const response = await getProfile()
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)


// ===============================
// 2 -> Update Profile
// ===============================
export const updateUserProfile = createAsyncThunk(
  "user/updateProfile",
  async (data, thunkAPI) => {
    try {
      const response = await updateProfile(data)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)


// ===============================
// 3 -> Upload Profile Image
// ===============================
export const uploadUserImage = createAsyncThunk(
  "user/uploadImage",
  async (file, thunkAPI) => {
    try {
      const response = await uploadProfileImage(file)
      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)


// ===============================
// Slice
// ===============================
const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    setUser: (state, action) => {

      state.user = action.payload.data.data[0]
    },
    clearUserError: (state) => {
      state.error = null
    },

    clearUserMessage: (state) => {
      state.message = null
    },

    clearUser: (state) => {
      state.user = null
      state.loading = false
      state.error = null
      state.message = null
    }

  },

  extraReducers: (builder) => {

    builder

      // ===============================
      // FETCH PROFILE
      // ===============================
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload.data[0]
        state.message = action.payload.message
        state.checked = true
      })

      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload?.message || "Failed to fetch profile"
        state.checked = true
      })


      // ===============================
      // UPDATE PROFILE
      // ===============================
      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload.data[0]
        state.message = action.payload.message || "Profile updated"
      })

      .addCase(updateUserProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload?.message || "Profile update failed"
      })


      // ===============================
      // UPLOAD PROFILE IMAGE
      // ===============================
      .addCase(uploadUserImage.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(uploadUserImage.fulfilled, (state, action) => {
        state.loading = false

        const image = action.payload?.data?.[0]?.profile_image

        if (state.user && image) {
          state.user = {
            ...state.user,
            profile_image: image
          }
        }

        state.message = action.payload.message || "Image uploaded"
      })

      .addCase(uploadUserImage.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload?.message || "Image upload failed"
      })

  }
})

export const {
  setUser,
  clearUserError,
  clearUserMessage,
  clearUser
} = userSlice.actions

export default userSlice.reducer